import React from 'react';
import classNames from 'classnames';
import { ListingCard } from '../../../components';

import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';

function SectionRecentlyAdded(props) {
  const { listings = [], intl } = props;

  return (
    <div className={classNames(css.popularSessions, css.sectionPadding, css.justInSec)}>
      <div className={css.fixedWidthContainer}>
        <h1 className={css.heading}>
          {intl.formatMessage({ id: 'SectionRecentlyAdded.recentlyListed' })}{' '}
          <Icons name="rightArrow" />
        </h1>
        <div className={css.sectionListings}>
          <div className={css.customSlider}>
            {listings.map(l => (
              <ListingCard
                className={css.listingCard}
                key={l?.id?.uuid}
                listing={l}
                setActiveListing={() => {}}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionRecentlyAdded;
